import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Quote, Youtube } from "@cinch-labs/design-system";
import { ArticleHeader } from "@cinch-nx/landing-ui-articles";
import { Head, JsonLdScript, formatHowToSchema } from "@cinch-nx/landing-ui-shared";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
import { Wrapper } from "@cinch-nx/shared-ui";
import cx from "classnames";
import styles from "./articles.module.css";
import { ArticleBody, ArticleRelatedJargon, LeadParagraph } from "./components";
export const ArticlesFeature = ({ story , preview  })=>{
    var ref, ref1, ref2, ref3, ref4;
    const typedStory = story;
    const { content  } = useStoryblokState({
        story: typedStory,
        options: {
            resolveRelations: [
                "ArticleTemplate.relatedJargon"
            ]
        },
        enableBridge: preview
    });
    const { title , subTitle , video , image , leadParagraph , quote , body , SEO  } = content;
    const seoDescription = SEO && ((ref = SEO[0]) === null || ref === void 0 ? void 0 : ref.description);
    const hasRelatedJargon = typedStory.rels && ((ref1 = typedStory.rels) === null || ref1 === void 0 ? void 0 : ref1.length) > 0;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                ...SEO,
                fallbackTitle: `${title} - cinch`,
                fallbackDescription: seoDescription || subTitle
            }),
            /*#__PURE__*/ _jsxs("article", {
                className: styles.page,
                "data-testid": "article-wrapper",
                children: [
                    SEO && ((ref2 = SEO[0]) === null || ref2 === void 0 ? void 0 : ref2.HowTo) && Array.isArray((ref3 = SEO[0]) === null || ref3 === void 0 ? void 0 : ref3.HowTo) && ((ref4 = SEO[0]) === null || ref4 === void 0 ? void 0 : ref4.HowTo.length) > 0 && /*#__PURE__*/ _jsx(JsonLdScript, {
                        schema: formatHowToSchema(SEO[0].HowTo),
                        tagId: "HowToPage"
                    }),
                    /*#__PURE__*/ _jsxs(Wrapper, {
                        isSlim: true,
                        children: [
                            /*#__PURE__*/ _jsx(ArticleHeader, {
                                title: title,
                                subTitle: subTitle,
                                video: video,
                                image: image
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.content,
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: cx(styles.main, {
                                            [styles.mainNoPadding]: !hasRelatedJargon
                                        }),
                                        children: [
                                            (video === null || video === void 0 ? void 0 : video.length) > 0 ? /*#__PURE__*/ _jsx(Youtube, {
                                                videoId: video[0].videoId,
                                                title: video[0].title,
                                                buttonLabel: video[0].buttonLabel,
                                                className: styles.video,
                                                customThumbnail: video[0].thumbnail.filename !== "" ? video[0].thumbnail.filename : image.filename,
                                                videoUrlOptions: {
                                                    autoplay: 1
                                                },
                                                showNewPlayIcon: true
                                            }) : null,
                                            /*#__PURE__*/ _jsx(LeadParagraph, {
                                                body: leadParagraph
                                            }),
                                            quote ? /*#__PURE__*/ _jsx(Quote, {
                                                text: quote
                                            }) : null,
                                            /*#__PURE__*/ _jsx(ArticleBody, {
                                                body: body
                                            })
                                        ]
                                    }),
                                    hasRelatedJargon && /*#__PURE__*/ _jsx("aside", {
                                        className: styles.jargonBuster,
                                        children: /*#__PURE__*/ _jsx(ArticleRelatedJargon, {
                                            items: typedStory.rels
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
